<template>
    <div>
        <div class="row">
            <h5 class="col-sm-4 col-md-4 text-grey">{{ __('Time Zone') }}</h5>
        </div>
        <div class="row">
            <Timeline>
                <TimelineItem
                    :key="item.id"
                    v-for="(item, index) in timelineData"
                >
                    <span :class="iconColors[index]" class="timeline-circle">
                        <font-awesome-icon :icon="item.icon"></font-awesome-icon>
                    </span>

                    <span slot="item_content">
                        {{ item.title }}<br/>

                        <span class="text-silver small">
                            {{ dateFormat(item.date) }}
                        </span>
                    </span>
                </TimelineItem>
            </Timeline>
        </div>
    </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'TimeZone',

  props: {
    timelineData: Array
  },

  data () {
    return {
      moment,
      iconColors: ['circle-green', 'circle-violet', 'circle-red', 'circle-orange']
    }
  },

  methods: {
    dateFormat (item) {
      return moment(item).format('YYYY-MM-DD')
    }
  }
}
</script>
